module.exports = __webpack_public_path__ + "static/media/iconfinder_1_Slack_colored_svg_5296507.9ddc6f26.png";